// @ts-nocheck
import { compose } from "modules/core"
import PocOrganizationHomeView from "modules/poc-dashboard/components/organization/oraganizationHomeView"
import React from "react"
import { withApollo } from '@apollo/client/react/hoc';
import { VERTICAL_TOTAL_COUNT } from "modules/poc-dashboard/graphql/pocDashboardQuery.gql";
import { globalPermissionValidator } from "modules/look";
import { poc_admin_permission } from "Permissions/poc_admin.permission";
import NoPermissionView from "modules/kudos-user/component/NoPermissionComponent";
import { Spin } from "antd";
import am_dashboard_routes from "modules/poc-dashboard/account-manager/routes";
import { getOrgID } from "./organizationOperations";
import poc_dashboard_routes from "modules/poc-dashboard/routes";

const PocOrganizationHomeContainer = (props) => {
    const { me, client, userPermission, location, orgToFetchData } = props
    const [verticals_count, setVerticalCount] = React.useState()
    const [permission, setPermission] = React.useState()
    const [hasSubVertical, setHasSubVertical] = React.useState(false)

    const updateHasSubVertical = React.useCallback((hasSubVert) => {
        setHasSubVertical(hasSubVert);
    }, []);

    //Permission Check
    React.useEffect(() => {
        if (userPermission?.length && me) {
            let permissions = globalPermissionValidator(poc_admin_permission, userPermission)
            if (permissions?.required_permission && !me?.employee?.orgAmEmployee?.totalCount) {
                if (permissions.required_permission && !me?.employee?.orgPocEmployee?.totalCount) {
                    permissions.required_permission = false
                }
                if (permissions.required_permission && !me?.employee?.organizationSet?.edges?.length) {
                    permissions.required_permission = false
                }
                if (permissions.required_permission && Object.values(am_dashboard_routes).some(routes => location?.pathname.includes(routes))) {
                    permissions.required_permission = false
                }
            } else if (me?.employee?.orgAmEmployee?.totalCount && !me?.employee?.orgPocEmployee?.totalCount) {
                if (permissions.required_permission && Object.values(poc_dashboard_routes).some(routes => location?.pathname.includes(routes))) {
                    permissions.required_permission = false
                }
            }

            if (JSON.stringify(permissions) !== JSON.stringify(permission)) {
                setPermission(permissions)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPermission, me])

    React.useEffect(() => {
        if (permission?.required_permission && (orgToFetchData?.id || getOrgID(props))) {
            verticalCount()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permission, orgToFetchData])

    const verticalCount = async () => {
        try {
            const { data } = await client.query({
                query: VERTICAL_TOTAL_COUNT,
                fetchPolicy: 'network-only',
                variables: {
                    id: getOrgID(props) || orgToFetchData?.id
                }
            });
            if (data?.organizationById?.verticalSet) {
                setVerticalCount(data?.organizationById?.verticalSet?.totalCount)
            }
        }
        catch (e) {
            console.error("organizationHomeContainer -> verticalCount", e)
        }
    }
    return (
        <>
            {(permission && !permission?.required_permission) && (<NoPermissionView />)}

            {(permission && permission?.required_permission) && (
                <PocOrganizationHomeView 
                    {...props} 
                    verticals_count={verticals_count} 
                    verticalCount={verticalCount}
                    hasSubVertical={hasSubVertical}
                    onSubVerticalUpdate={updateHasSubVertical}
                />
            )}
            
            {!permission && (
                <div className="role-no-permission-container">
                    <Spin spinning={true} size="large"></Spin>
                </div>
            )}
        </>
    )
}

export default compose(withApollo)(PocOrganizationHomeContainer)